import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { LegalAssistanceRequest } from '../models/legal-assistance-request.model';
import { LegalAssistanceResponse } from '../models/legal-assistance-response.model';
import { LegalAssistanceSubserviceRequest } from '../models/legal-assistance-subservice-request.model';
import { LegalAssistanceSubserviceResponse } from '../models/legal-assistance-subservice-response.model';

@Injectable({
  providedIn: 'root',
})
export class LegalAssistanceService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}

  postLegalAssistance(request: LegalAssistanceRequest): Observable<LegalAssistanceResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/file/${cognitoId}/add`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    });
    
    // Override poliza key if selected
    this.overridePolizaKey(request);
    
    return this.http.post<LegalAssistanceResponse>(url, request, { headers });
  }

  private overridePolizaKey(data: any): void {
    if (data && data.petition) {
      const selectedPoliza = localStorage.getItem('selectedPoliza');
      if (selectedPoliza) {
        try {
          const poliza = JSON.parse(selectedPoliza);
          if (data.petition.key) {
            data.petition.key = poliza.insurance;
          }
        } catch (e) {
          console.warn('Error parsing selectedPoliza:', e);
        }
      }
    }
  }

  postLegalAssistanceSubservice(request: LegalAssistanceSubserviceRequest): Observable<LegalAssistanceSubserviceResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/subservices/254`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    });
    return this.http.post<LegalAssistanceSubserviceResponse>(url, request, { headers });
  }

}
